module.exports = __webpack_public_path__ + "img/open_in_safari.18d6cbec.png";